// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/checklist-hero-bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.checklist-page {
  width: 100%;
  margin-top: -80px;
}

.checklist-hero {
  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),
              url(${___CSS_LOADER_URL_REPLACEMENT_0___}) center/cover no-repeat;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  text-align: center;
  color: white;
  padding-top: calc(80px + 4rem);
}

.checklist-hero-content {
  max-width: 1200px;
  margin: 0 auto;
}

.checklist-hero h1 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 3.5rem;
  margin-bottom: 1.5rem;
  font-weight: 600;
  color: #D4AF37;
}

.checklist-hero p {
  font-size: 1.25rem;
  max-width: 800px;
  margin: 0 auto 3rem;
  line-height: 1.6;
}

.hero-stats {
  display: flex;
  justify-content: center;
  gap: 4rem;
  margin-top: 2rem;
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.stat-number {
  font-size: 2.5rem;
  font-weight: bold;
  color: #D4AF37;
  margin-bottom: 0.5rem;
}

.stat-label {
  font-size: 1.1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
}

@media (max-width: 768px) {
  .checklist-hero h1 {
    font-size: 2.5rem;
  }

  .checklist-hero p {
    font-size: 1.1rem;
  }

  .hero-stats {
    gap: 2rem;
    flex-wrap: wrap;
  }

  .stat-number {
    font-size: 2rem;
  }

  .stat-label {
    font-size: 1rem;
  }
}

.checklist-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 2rem;
}

.checklist-table {
  background: transparent;
  margin-bottom: 2rem;
  overflow: visible;
  position: relative;
}

.checklist-header {
  padding: 1.5rem;
  background: #271F12;
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease;
  border-radius: 10px;
  margin-bottom: 0.5rem;
  position: relative;
}

.checklist-header:hover {
  background: #3a2d1a;
}

.area-header {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.area-icon {
  font-size: 1.5rem;
}

.expand-icon {
  position: absolute;
  right: -40px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 1.5rem;
  color: #271F12;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.checklist-table.expanded .expand-icon {
  transform: translateY(-50%) rotate(90deg);
}

.checklist-items {
  background: white;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-height: 0;
  overflow: hidden;
  transition: all 0.5s ease;
  opacity: 0;
  transform: translateY(-20px);
}

.checklist-table.expanded .checklist-items {
  max-height: 2000px;
  opacity: 1;
  transform: translateY(0);
  padding: 1rem 0;
}

.checklist-table:not(.expanded) .checklist-items {
  max-height: 0;
  padding: 0;
  margin: 0;
}

.area-header h2 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.5rem;
  color: white;
  margin: 0;
}

.service-types {
  display: flex;
  gap: 2rem;
}

.service-types span {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1rem;
  min-width: 120px;
  text-align: center;
  font-weight: 500;
  position: relative;
}

.checklist-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #eee;
  transition: background-color 0.2s ease;
  text-align: left;
}

.checklist-item:hover {
  background-color: rgba(82, 96, 21, 0.02);
}

.checklist-item:last-child {
  border-bottom: none;
}

.task-name {
  font-size: 1rem;
  color: #526015;
  flex: 1 1;
  padding-right: 2rem;
  text-align: left;
}

.task-name em {
  color: rgba(82, 96, 21, 0.7);
  font-style: normal;
  font-size: 0.9rem;
  margin-left: 0.5rem;
}

.service-checks {
  display: flex;
  gap: 2rem;
}

.check {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  font-size: 1.25rem;
  color: rgba(82, 96, 21, 0.3);
}

.check.included {
  color: #D4AF37;
}

@media (max-width: 768px) {
  .checklist-header {
    flex-direction: column;
    gap: 1rem;
    text-align: center;
  }

  .service-types {
    width: 100%;
    justify-content: space-around;
    gap: 0.5rem;
  }

  .service-types span {
    min-width: auto;
    font-size: 0.9rem;
  }

  .checklist-item {
    flex-direction: column;
    gap: 1rem;
    text-align: left;
    padding: 1.5rem;
  }

  .task-name {
    padding-right: 0;
    text-align: left;
    width: 100%;
  }

  .service-checks {
    width: 100%;
    justify-content: space-around;
  }

  .check {
    width: auto;
  }

  .expand-icon {
    right: -20px;
    width: 25px;
    height: 25px;
    font-size: 1.2rem;
  }
}

.area-title {
  display: flex;
  flex-direction: column;
}

.area-title h2 {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 1.5rem;
  color: white;
  margin: 0;
}

.area-subtitle {
  font-size: 0.9rem;
  opacity: 0.9;
  margin-top: 0.25rem;
  font-family: 'Josefin Sans', sans-serif;
} `, "",{"version":3,"sources":["webpack://./src/styles/Checklist.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE;4EACyE;EACzE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,sCAAsC;EACtC,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,iBAAiB;EACjB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,6BAA6B;EAC7B,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAO;EACP,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,6BAA6B;IAC7B,WAAW;EACb;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,WAAW;IACX,6BAA6B;EAC/B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;AACzC","sourcesContent":[".checklist-page {\n  width: 100%;\n  margin-top: -80px;\n}\n\n.checklist-hero {\n  background: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)),\n              url('../assets/checklist-hero-bg.jpg') center/cover no-repeat;\n  min-height: 60vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  text-align: center;\n  color: white;\n  padding-top: calc(80px + 4rem);\n}\n\n.checklist-hero-content {\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.checklist-hero h1 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 3.5rem;\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n  color: #D4AF37;\n}\n\n.checklist-hero p {\n  font-size: 1.25rem;\n  max-width: 800px;\n  margin: 0 auto 3rem;\n  line-height: 1.6;\n}\n\n.hero-stats {\n  display: flex;\n  justify-content: center;\n  gap: 4rem;\n  margin-top: 2rem;\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.stat-number {\n  font-size: 2.5rem;\n  font-weight: bold;\n  color: #D4AF37;\n  margin-bottom: 0.5rem;\n}\n\n.stat-label {\n  font-size: 1.1rem;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n@media (max-width: 768px) {\n  .checklist-hero h1 {\n    font-size: 2.5rem;\n  }\n\n  .checklist-hero p {\n    font-size: 1.1rem;\n  }\n\n  .hero-stats {\n    gap: 2rem;\n    flex-wrap: wrap;\n  }\n\n  .stat-number {\n    font-size: 2rem;\n  }\n\n  .stat-label {\n    font-size: 1rem;\n  }\n}\n\n.checklist-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 4rem 2rem;\n}\n\n.checklist-table {\n  background: transparent;\n  margin-bottom: 2rem;\n  overflow: visible;\n  position: relative;\n}\n\n.checklist-header {\n  padding: 1.5rem;\n  background: #271F12;\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n  transition: background-color 0.3s ease;\n  border-radius: 10px;\n  margin-bottom: 0.5rem;\n  position: relative;\n}\n\n.checklist-header:hover {\n  background: #3a2d1a;\n}\n\n.area-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.area-icon {\n  font-size: 1.5rem;\n}\n\n.expand-icon {\n  position: absolute;\n  right: -40px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 1.5rem;\n  color: #271F12;\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: white;\n  border-radius: 50%;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease;\n}\n\n.checklist-table.expanded .expand-icon {\n  transform: translateY(-50%) rotate(90deg);\n}\n\n.checklist-items {\n  background: white;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  max-height: 0;\n  overflow: hidden;\n  transition: all 0.5s ease;\n  opacity: 0;\n  transform: translateY(-20px);\n}\n\n.checklist-table.expanded .checklist-items {\n  max-height: 2000px;\n  opacity: 1;\n  transform: translateY(0);\n  padding: 1rem 0;\n}\n\n.checklist-table:not(.expanded) .checklist-items {\n  max-height: 0;\n  padding: 0;\n  margin: 0;\n}\n\n.area-header h2 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.5rem;\n  color: white;\n  margin: 0;\n}\n\n.service-types {\n  display: flex;\n  gap: 2rem;\n}\n\n.service-types span {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1rem;\n  min-width: 120px;\n  text-align: center;\n  font-weight: 500;\n  position: relative;\n}\n\n.checklist-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid #eee;\n  transition: background-color 0.2s ease;\n  text-align: left;\n}\n\n.checklist-item:hover {\n  background-color: rgba(82, 96, 21, 0.02);\n}\n\n.checklist-item:last-child {\n  border-bottom: none;\n}\n\n.task-name {\n  font-size: 1rem;\n  color: #526015;\n  flex: 1;\n  padding-right: 2rem;\n  text-align: left;\n}\n\n.task-name em {\n  color: rgba(82, 96, 21, 0.7);\n  font-style: normal;\n  font-size: 0.9rem;\n  margin-left: 0.5rem;\n}\n\n.service-checks {\n  display: flex;\n  gap: 2rem;\n}\n\n.check {\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  width: 120px;\n  font-size: 1.25rem;\n  color: rgba(82, 96, 21, 0.3);\n}\n\n.check.included {\n  color: #D4AF37;\n}\n\n@media (max-width: 768px) {\n  .checklist-header {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: center;\n  }\n\n  .service-types {\n    width: 100%;\n    justify-content: space-around;\n    gap: 0.5rem;\n  }\n\n  .service-types span {\n    min-width: auto;\n    font-size: 0.9rem;\n  }\n\n  .checklist-item {\n    flex-direction: column;\n    gap: 1rem;\n    text-align: left;\n    padding: 1.5rem;\n  }\n\n  .task-name {\n    padding-right: 0;\n    text-align: left;\n    width: 100%;\n  }\n\n  .service-checks {\n    width: 100%;\n    justify-content: space-around;\n  }\n\n  .check {\n    width: auto;\n  }\n\n  .expand-icon {\n    right: -20px;\n    width: 25px;\n    height: 25px;\n    font-size: 1.2rem;\n  }\n}\n\n.area-title {\n  display: flex;\n  flex-direction: column;\n}\n\n.area-title h2 {\n  font-family: 'Josefin Sans', sans-serif;\n  font-size: 1.5rem;\n  color: white;\n  margin: 0;\n}\n\n.area-subtitle {\n  font-size: 0.9rem;\n  opacity: 0.9;\n  margin-top: 0.25rem;\n  font-family: 'Josefin Sans', sans-serif;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
